import type { AdminEvent } from "@/lib/admin-api-types";

const EVENTS_KEY = "__aja_mock_events__";
const EVENTS_SEEDED_KEY = "__aja_mock_events_seeded__";

type MockGlobal = typeof globalThis & {
  [EVENTS_KEY]?: AdminEvent[];
  [EVENTS_SEEDED_KEY]?: boolean;
};

export function getMockEventsArray(): AdminEvent[] {
  const g = globalThis as MockGlobal;
  if (!g[EVENTS_KEY]) {
    g[EVENTS_KEY] = [];
  }
  return g[EVENTS_KEY];
}

export function isMockEventsSeeded(): boolean {
  return (globalThis as MockGlobal)[EVENTS_SEEDED_KEY] ?? false;
}

export function setMockEventsSeeded(seeded: boolean) {
  (globalThis as MockGlobal)[EVENTS_SEEDED_KEY] = seeded;
}
